// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { loadingToggler } from 'redux/modules/loading'
import { error } from 'react-notification-system-redux'
import { throwSubmissionError } from 'helpers/reduxFormFunctions'
import removeErroneousRadioModulationIdFromErrors from './removeErroneousRadioModulationIdFromErrors'

import {
  prepRadioData,
  updateEntityDetails,
} from 'redux/modules/databaseDetails'

import {
  postNewRadio,
  updateRadio,
} from 'helpers/api'
import { Success } from 'components/Modals'

const submitRadio = (formValues, d, formProps) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { openContextModal } = formProps

      const { databaseDetails } = getState()

      const isNewEntity = databaseDetails.get('isNewEntity')

      // Radio Modulations are edited through redux-form but when we save them, we store them here
      // in databaseDetails redux store. then on submit we take that data as the submit values for
      // handling submit on the modulation's radio.
      const radioModulations = databaseDetails.getIn(['initialValues', 'radioModulations']).toJS()
      const preppedData = prepRadioData(formValues, radioModulations)

      try {
        const { entity } = (
          isNewEntity
            ? await postNewRadio(preppedData)
            : await updateRadio(preppedData)
        )

        const {
          radioCode,
          radioId,
        } = entity

        await dispatch(updateEntityDetails(radioId))

        const modalHeading = `Successfully ${isNewEntity ? 'created new' : 'updated'} radio`
        const modalMessage = `${radioCode} was successfully ${isNewEntity ? 'created' : 'updated'}.`

        openContextModal(
          <div className={'padding-half'}>
            <Success
              modalHeading={modalHeading}
              modalMessage={modalMessage} />
          </div>
        )
      } catch (err) {
        console.warn(err)

        dispatch(removeErroneousRadioModulationIdFromErrors(err))

        dispatch(error({
          autoDismiss: 0,
          message: err.message,
        }))

        throwSubmissionError(err)
      }
    })
  )
)

export default submitRadio
